import { render, staticRenderFns } from "./SubscriberCount.vue?vue&type=template&id=26bee964&scoped=true"
import script from "./SubscriberCount.vue?vue&type=script&lang=js"
export * from "./SubscriberCount.vue?vue&type=script&lang=js"
import style0 from "./SubscriberCount.vue?vue&type=style&index=0&id=26bee964&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bee964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bee964')) {
      api.createRecord('26bee964', component.options)
    } else {
      api.reload('26bee964', component.options)
    }
    module.hot.accept("./SubscriberCount.vue?vue&type=template&id=26bee964&scoped=true", function () {
      api.rerender('26bee964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/SubscriberCount.vue"
export default component.exports